import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dual-range-slider',
  templateUrl: './dual-range-slider.component.html',
  styleUrls: ['./dual-range-slider.component.scss']
})
export class DualRangeSliderComponent implements AfterViewInit {
  @Output() valueChange = new EventEmitter<{ from: number; to: number }>();

  ngAfterViewInit() {
    const COLOR_TRACK = "#CBD5E1";
    const COLOR_RANGE = "#0EA5E9";

    const fromSlider = document.querySelector('#fromSlider') as HTMLInputElement;
    const toSlider = document.querySelector('#toSlider') as HTMLInputElement;
    const fromTooltip = document.querySelector('#fromSliderTooltip') as HTMLElement;
    const toTooltip = document.querySelector('#toSliderTooltip') as HTMLElement;
    const scale = document.getElementById('scale') as HTMLElement;

    if (!fromSlider || !toSlider || !fromTooltip || !toTooltip || !scale) {
      console.error("One or more required elements are missing.");
      return;
    }

    const MIN = parseInt(fromSlider.getAttribute('min') || '0', 10);
    const MAX = parseInt(fromSlider.getAttribute('max') || '100', 10);
    const STEPS = parseInt(scale.dataset['steps'] || '10', 10);

    fromSlider.oninput = () => {
      this.controlFromSlider(fromSlider, toSlider, fromTooltip, toTooltip, COLOR_TRACK, COLOR_RANGE);
      this.emitSliderValues(fromSlider, toSlider);
    };

    toSlider.oninput = () => {
      this.controlToSlider(fromSlider, toSlider, fromTooltip, toTooltip, COLOR_TRACK, COLOR_RANGE);
      this.emitSliderValues(fromSlider, toSlider);
    };

    this.fillSlider(fromSlider, toSlider, COLOR_TRACK, COLOR_RANGE, toSlider);
    this.setTooltip(fromSlider, fromTooltip);
    this.setTooltip(toSlider, toTooltip);
    this.createScale(MIN, MAX, STEPS, scale);
  }

  private emitSliderValues(fromSlider: HTMLInputElement, toSlider: HTMLInputElement) {
    const from = parseInt(fromSlider.value, 10);
    const to = parseInt(toSlider.value, 10);
    this.valueChange.emit({ from, to });
  }

  private controlFromSlider(
    fromSlider: HTMLInputElement,
    toSlider: HTMLInputElement,
    fromTooltip: HTMLElement,
    toTooltip: HTMLElement,
    trackColor: string,
    rangeColor: string
  ) {
    const [from, to] = this.getParsedValues(fromSlider, toSlider);
    this.fillSlider(fromSlider, toSlider, trackColor, rangeColor, toSlider);
    if (from > to) {
      fromSlider.value = to.toString();
    }
    this.setTooltip(fromSlider, fromTooltip);
  }

  private controlToSlider(
    fromSlider: HTMLInputElement,
    toSlider: HTMLInputElement,
    fromTooltip: HTMLElement,
    toTooltip: HTMLElement,
    trackColor: string,
    rangeColor: string
  ) {
    const [from, to] = this.getParsedValues(fromSlider, toSlider);
    this.fillSlider(fromSlider, toSlider, trackColor, rangeColor, toSlider);
    if (from <= to) {
      toSlider.value = to.toString();
    } else {
      toSlider.value = from.toString();
    }
    this.setTooltip(toSlider, toTooltip);
  }

  private getParsedValues(fromSlider: HTMLInputElement, toSlider: HTMLInputElement): [number, number] {
    const from = parseInt(fromSlider.value, 10);
    const to = parseInt(toSlider.value, 10);
    return [from, to];
  }

  private fillSlider(
    from: HTMLInputElement,
    to: HTMLInputElement,
    trackColor: string,
    rangeColor: string,
    controlSlider: HTMLInputElement
  ) {
    const rangeDistance = parseInt(to.max, 10) - parseInt(to.min, 10);
    const fromPosition = from.valueAsNumber - parseInt(to.min, 10);
    const toPosition = to.valueAsNumber - parseInt(to.min, 10);
    controlSlider.style.background = `linear-gradient(
      to right,
      ${trackColor} 0%,
      ${trackColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
      ${trackColor} ${(toPosition / rangeDistance) * 100}%, 
      ${trackColor} 100%)`;
  }

  private setTooltip(slider: HTMLInputElement, tooltip: HTMLElement) {
    const value = slider.valueAsNumber;
    tooltip.textContent = `${value}%`;
    const percent = ((value - parseInt(slider.min, 10)) / (parseInt(slider.max, 10) - parseInt(slider.min, 10))) * 100;
    tooltip.style.left = `calc(${percent}% - 0px)`;
  }

  private createScale(min: number, max: number, step: number, scaleElement: HTMLElement) {
    const range = max - min;
    const steps = range / step;
    for (let i = 0; i <= steps; i++) {
      const value = min + i * step;
      const percent = ((value - min) / range) * 100;
      const marker = document.createElement('div');
      marker.style.left = `${percent}%`;
      marker.textContent = `${value}%`;
      scaleElement.appendChild(marker);
    }
  }
}
